module.exports = __webpack_public_path__ + "img/bin-c-4.b59fb44e.svg";